import { isNumberCoercible } from './isNumberCoercible';

export const mapToSortedArray = <TKeyType, TValueType>(map: Map<TKeyType, TValueType>): [TKeyType, TValueType][] => {
  return Array.from(map.entries()).sort(([aX], [bX]) => {
    if (isNumberCoercible(aX) && isNumberCoercible(bX)) {
      return aX.valueOf() - bX.valueOf();
    }
    // default string comparison
    return aX < bX ? -1 : 1;
  });
};
